import { createIcon } from '@chakra-ui/react'

export const Account = createIcon({
  displayName: 'Account',
  viewBox: '0 0 20 20',
  d: 'M10 4C11.1 4 12 4.9 12 6C12 7.1 11.1 8 10 8C8.9 8 8 7.1 8 6C8 4.9 8.9 4 10 4ZM10 14C12.7 14 15.8 15.29 16 16H4C4.23 15.28 7.31 14 10 14ZM10 2C7.79 2 6 3.79 6 6C6 8.21 7.79 10 10 10C12.21 10 14 8.21 14 6C14 3.79 12.21 2 10 2ZM10 12C7.33 12 2 13.34 2 16V18H18V16C18 13.34 12.67 12 10 12Z',
})
